import * as PropTypes from "prop-types";
import React, {Component} from "react";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {DefaultBtn} from "Ncontracts.Common.UI";
import "./_style.scss";
import ImageCheckbox from "../common/ImageCheckbox";
import {
    refreshData,
    resetFilterOnClearButtonClick,
    toggleBcpFunctionFilter,
    toggleEventFilters,
    toggleInherentRiskFilter,
    toggleResidualRiskFilter
} from "../../actions/vendors/vendorConcentrationMapAction";
import {toggleMapOverlay} from "../../actions/maps/mapOverlayAction";
import { VendorFilterModel } from "../../Models/vendors/VendorModel";
import { IconDropdownModel } from "../common/IconDropdown/_model";
import IconDropdown from "../common/IconDropdown/IconDropdown";


class VendorConcentrationMapFilter extends Component {
    static propTypes = {
        mapOverlayOptions: PropTypes.arrayOf(PropTypes.shape(IconDropdownModel)),
        getFilters: PropTypes.func,
        fetchAllRegulatoryContent: PropTypes.func,
        filterOptions: PropTypes.shape(VendorFilterModel),
        refreshData: PropTypes.func,
        resetFilterOnClearButtonClick: PropTypes.func,
        toggleMapOverlay: PropTypes.func,
        toggleBcpFunctionFilter: PropTypes.func,
        toggleCategoryFilter: PropTypes.func,
        toggleEventFilters: PropTypes.func,
        toggleFilterPanel: PropTypes.func,
        toggleInherentRiskFilter: PropTypes.func,
        toggleResidualRiskFilter: PropTypes.func
    };


    constructor(props) {
        super(props);
        this.state = {
            selectAll: false,
            categories: {
                items: [
                    {
                        display: "Inherent Risk"
                    },
                    {
                        display: "Residual Risk"
                    },
                    {
                        display: "BCP Functions"
                    },
                    {
                        display: "Active Data Overlay"
                    },
                    {
                        display: "Events"
                    }
                ]
                , visible: true
            }
        };
    }

    componentDidUpdate() {
        this.props.refreshData(this.props.filterOptions);
    }

    toggleInherentRiskFilter = riskFilterName => {
        this.props.toggleInherentRiskFilter(riskFilterName);
    };

    toggleResidualRiskFilter = riskFilterName => {
        this.props.toggleResidualRiskFilter(riskFilterName);
    };

    toggleBcpFunctionFilter = riskFilterName => {
        this.props.toggleBcpFunctionFilter(riskFilterName);
    };

    toggleMapOverlay = selectedOption => {
        this.props.toggleMapOverlay(selectedOption.id);
    };

    toggleEventFilters = eventFilterName => {
        this.props.toggleEventFilters(eventFilterName);
    };

    createFilterItemList = (items, clickHandler) => {
        return items.map((filterItem, idx) => {
            return <div className="filter-item" key={`Filter:${filterItem.name}:${idx}`}>
                <div className="checkbox-with-label" onClick={() => clickHandler(filterItem.name)}>
                    <div className="checkbox">
                        <ImageCheckbox isSelected={filterItem.isSelected}/>
                    </div>
                    <div className="checkbox-label">
                        {filterItem.name}
                    </div>
                </div>
            </div>;
        });
    };

    createDefaultDisabledItemList = (items) => {
        return items.map((filterItem, idx) => {
            return <div className="filter-item" key={`Filter:${filterItem.name}:${idx}`}>
                <div className="checkbox-with-label">
                    <div className="disabled-checkbox">
                        <ImageCheckbox isSelected={false} isDisabled />
                    </div>
                    <div className="disabled-checkbox-label">
                        {filterItem.name}
                    </div>
                </div>
            </div>;
        });
    };

    handleCloseLinkClick = () => {
        this.props.toggleFilterPanel();
    };

    renderClearButton = (propName) => {
        return (
            <span className="clearButtonRight">
                <DefaultBtn className="btn--base btn--smaller"
                            onClick={() => this.props.resetFilterOnClearButtonClick(propName)}>
                    CLEAR
                    </DefaultBtn>
            </span>
        );
    };

    renderInherentRiskSection = () => {
        const categories = this.state.categories;
        const inherentRiskLabel = categories.items.map(x => x.display).filter(z => z.includes('Inherent'));
        const filtersList = this.props.filterOptions.inherentRiskFilterOptions;
        const hasVendorManagementFilters = this.props.filterOptions.hasVendorManagementRiskFilters;
        const selectedFilters = filtersList.filter(x => x.isSelected);

        if (categories.visible === true) {
            return (
                <div className="control filterContainer">
                    <div className="subheader">
                        {inherentRiskLabel}
                        {selectedFilters.length ? this.renderClearButton("inherentRiskFilterOptions") : undefined}
                    </div>
                    {hasVendorManagementFilters ?
                        this.createFilterItemList(this.props.filterOptions.inherentRiskFilterOptions, this.toggleInherentRiskFilter) :
                        this.createDefaultDisabledItemList(this.props.filterOptions.inherentRiskFilterOptions)}
                </div>);
        }
        return "";
    };

    renderResidualRiskSection = () => {
        const categories = this.state.categories;
        const residualLabel = categories.items.map(x => x.display).filter(z => z.includes('Residual'));
        const filtersList = this.props.filterOptions.residualRiskFilterOptions;
        const hasVendorManagementFilters = this.props.filterOptions.hasVendorManagementRiskFilters;
        const selectedFilters = filtersList.filter(x => x.isSelected);

        if (categories.visible === true) {
            return (
                <div className="control filterContainer">
                    <div className="subheader">
                        {residualLabel}
                        {selectedFilters.length ? this.renderClearButton("residualRiskFilterOptions") : undefined}
                    </div>
                    {hasVendorManagementFilters ?
                        this.createFilterItemList(this.props.filterOptions.residualRiskFilterOptions, this.toggleResidualRiskFilter) :
                        this.createDefaultDisabledItemList(this.props.filterOptions.residualRiskFilterOptions)}
                </div>);
        }
        return "";
    };

    renderBcpFunctionsSection = () => {
        const categories = this.state.categories;
        const bcpFunctionLabel = categories.items.map(x => x.display).filter(z => z.includes('BCP'));
        const filtersList = this.props.filterOptions.functionFilterOptions;
        const selectedFilters = filtersList.filter(x => x.isSelected);

        if (categories.visible === true) {
            return (
                <div className="control filterContainer">
                    <div className="subheader">
                        {bcpFunctionLabel}
                        {selectedFilters.length ? this.renderClearButton("functionFilterOptions") : undefined}
                    </div>
                    {this.createFilterItemList(this.props.filterOptions.functionFilterOptions, this.toggleBcpFunctionFilter)}
                </div>);
        }
        return "";
    };

    renderBcpEventSection = () => {
        const categories = this.state.categories;
        const eventLabel = categories.items.map(x => x.display).filter(y => y.includes('Events'));
        const filtersList = this.props.filterOptions.eventFilterOptions;
        const selectedFilters = filtersList.filter(x => x.isSelected);

        if (categories.visible === true) {
            return (
                <div className="control filterContainer">
                    <div className="subheader">
                        {eventLabel}
                        {selectedFilters.length ? this.renderClearButton("eventFilterOptions") : undefined}
                    </div>
                    {this.createFilterItemList(this.props.filterOptions.eventFilterOptions, this.toggleEventFilters)}
                </div>);
        }
        return "";

    };

    renderMapOverlaySection() {
        const selectedOption = this.props.mapOverlayOptions.find(option => option.isSelected);
        return <div className="control filterContainer">
            <IconDropdown
                menuOptions={this.props.mapOverlayOptions}
                selectedOption={selectedOption}
                onChange={this.toggleMapOverlay} />
        </div>;
    }


    render() {
        return (
            <div className="filterStyle">
                <div className="filter-component">
                    <div className="level filterHeaderContainer">
                        <div className="level-left">
                            <div className="level-item filterHeader">
                                Filters
                            </div>
                        </div>
                        <div className="level-right">
                            <div className="level-item filterHeader">
                                <DefaultBtn className="btn--base"
                                            onClick={() => this.handleCloseLinkClick()}>CLOSE</DefaultBtn>
                            </div>
                        </div>
                    </div>
                    {this.renderMapOverlaySection()}
                    {this.renderBcpEventSection()}
                    {this.renderBcpFunctionsSection()}
                    {this.renderInherentRiskSection()}
                    {this.renderResidualRiskSection()}
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        mapOverlayOptions: state.mapOverlays.mapOverlayOptions,
    };
}

function mapDispatchToProps(dispatch) {

    return {
        toggleInherentRiskFilter: (riskFilterName) => dispatch(toggleInherentRiskFilter(riskFilterName)),
        toggleResidualRiskFilter: (riskFilterName) => dispatch(toggleResidualRiskFilter(riskFilterName)),
        toggleBcpFunctionFilter: (riskFilterName) => dispatch(toggleBcpFunctionFilter(riskFilterName)),
        toggleMapOverlay: (activeMapOverlayId) => dispatch(toggleMapOverlay(activeMapOverlayId)),
        resetFilterOnClearButtonClick: (filterName) => dispatch(resetFilterOnClearButtonClick(filterName)),
        refreshData: (filterOptions) => dispatch(refreshData(filterOptions)),
        toggleEventFilters: (eventFilterName) => dispatch(toggleEventFilters(eventFilterName))
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(VendorConcentrationMapFilter));
